export const privacy_tabs = [
  { id: 'dashboard', label: 'Dashboard' }, { id: 'pi-inventory', label: 'PI inventory' }, { id: 'processing-register', label: 'Processing register' }, { id: 'dsars', label: 'DSARs' }, { id: 'consent', label: 'Consent' }, { id: 'sharing-operators', label: 'Sharing & operators' }, { id: 'pias', label: 'PIAs' }, { id: 'retention', label: 'Retention' }, { id: 'cross-border', label: 'Cross-border' }, { id: 'incidents', label: 'Incidents' }
];

export const dashboard_hero = { score: '63', border: '#c75a06', chips: [{ label: '1 DSAR overdue', class: 'bg-danger-subtle text-danger-emphasis' }, { label: '1 operator agreement missing', class: 'bg-warning-subtle text-warning-emphasis' }, { label: '1 open incident', class: 'bg-warning-subtle text-warning-emphasis' }, { label: '1 retention overdue', class: 'bg-warning-subtle text-warning-emphasis' }] };

const dashboard_primary_row = [
  { title: 'PI inventory', value: '7', note: 'Across personal information elements', icon: 'bi-folder2', bg: '#e7f7f5', color: '#0f8d80', value_class: 'text-dark', tab_id: 'pi-inventory' },
  { title: 'Processing register', value: '6', note: 'Tracked activities', icon: 'bi-archive', bg: '#e7f7f5', color: '#0f8d80', value_class: 'text-dark', tab_id: 'processing-register' },
  { title: 'Data subject requests', value: '4', note: '4 open', icon: 'bi-people', bg: '#fdeceb', color: '#d65a52', value_class: 'text-dark', tab_id: 'dsars' },
  { title: 'Consent records', value: '4', note: 'Captured agreements', icon: 'bi-check2-square', bg: '#e7f7f5', color: '#0f8d80', value_class: 'text-dark', tab_id: 'consent' }
];

const dashboard_secondary_row = [
  { title: 'Data sharing & operators', value: '1', note: '1 no DPA', icon: 'bi-share', bg: '#fdeceb', color: '#d65a52', value_class: 'text-dark', tab_id: 'sharing-operators' },
  { title: 'Privacy impact assessments', value: '3', note: '3 due', icon: 'bi-shield-check', bg: '#fff1e1', color: '#c75a06', value_class: 'text-dark', tab_id: 'pias' },
  { title: 'Retention schedule', value: '5', note: 'Record classes', icon: 'bi-clock-history', bg: '#fdeceb', color: '#d65a52', value_class: 'text-dark', tab_id: 'retention' },
  { title: 'Cross-border transfers', value: '3', note: 'Reviewed destinations', icon: 'bi-arrow-up-right-square', bg: '#e7f7f5', color: '#0f8d80', value_class: 'text-dark', tab_id: 'cross-border' }
];

const dashboard_incidents_row = [
  { title: 'Privacy incidents', value: '1', note: '1 open', icon: 'bi-exclamation-triangle', bg: '#fdeceb', color: '#d65a52', value_class: 'text-dark', tab_id: 'incidents' }
];

export const dashboard_card_rows = [
  dashboard_primary_row,
  dashboard_secondary_row,
  dashboard_incidents_row
];

export const sensitivity_options = ['Standard', 'High'];
export const pi_inventory_status_options = ['Compliant', 'Review', 'Non-compliant'];
export const processing_basis_options = ['Consent', 'Contract', 'Legal obligation', 'Legitimate interest', 'Public interest', 'Vital interest'];
export const processing_status_options = ['Compliant', 'Review', 'Non-compliant'];
export const dsar_type_options = ['Access', 'Correction', 'Erasure', 'Objection (marketing)', 'Portability', 'Restriction'];
export const dsar_status_options = ['In progress', 'On clock', 'Overdue', 'Closed', 'Refused'];

export function badge_for_sensitivity(label) {
  const sensitivity_badge = label === 'High'
    ? { label, class: 'bg-danger-subtle text-danger-emphasis' }
    : { label, class: 'bg-success-subtle text-success-emphasis' };
  return sensitivity_badge;
}

export function badge_for_status(label) {
  if (label === 'Review') {
    const review_badge = { label, class: 'bg-warning-subtle text-warning-emphasis' };
    return review_badge;
  }
  if (label === 'Non-compliant') {
    const non_compliant_badge = { label, class: 'bg-danger-subtle text-danger-emphasis' };
    return non_compliant_badge;
  }
  const compliant_badge = { label, class: 'bg-success-subtle text-success-emphasis' };
  return compliant_badge;
}

export function create_pi_inventory_form() {
  const pi_inventory_form = { item: '', subject: '', category: '', system: '', source: '', linked_processing_activity: '', owner: '', sensitivity: 'Standard', status: 'Compliant' };
  return pi_inventory_form;
}

export function create_processing_form() {
  const processing_form = { activity: '', category: '', purpose: '', basis: 'Consent', owner: '', retention: '', safeguards: '', status: 'Compliant' };
  return processing_form;
}

export function create_dsar_form() {
  const dsar_form = { subject: '', type: 'Access', received: '', due: '', owner: '', status: 'In progress' };
  return dsar_form;
}

export function build_pi_inventory_row(row) {
  const sensitivity = badge_for_sensitivity(row.sensitivity_label || 'Standard');
  const status = badge_for_status(row.status_label || 'Compliant');
  const processing_link_row = {
    ref: row.ref,
    item: row.item,
    subject: row.subject,
    category: row.category,
    system: row.system,
    source: row.source,
    linked_processing_activity: row.linked_processing_activity,
    owner: row.owner,
    sensitivity,
    status,
    connected_records: row.connected_records || []
  };

  return processing_link_row;
}

export function build_processing_row(row) {
  const status = badge_for_status(row.status_label || 'Compliant');
  const register_row = {
    ref: row.ref,
    activity: row.activity,
    category: row.category,
    purpose: row.purpose,
    basis: row.basis,
    owner: row.owner,
    retention: row.retention,
    safeguards: row.safeguards,
    status,
    connected_records: row.connected_records || []
  };

  return register_row;
}

function parse_display_date(value) {
  if (!value) return null;
  const parts = value.trim().split(/\s+/);
  if (parts.length !== 3) return null;
  const [day, month, year] = parts;
  const iso = `${year}-${month}-${day}`;
  const parsed = new Date(iso);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

function days_between(start_date, end_date) {
  const milliseconds_per_day = 1000 * 60 * 60 * 24;
  return Math.round((end_date - start_date) / milliseconds_per_day);
}

function terminal_sla_label(status_label) {
  const terminal_status_map = {
    Closed: 'Met',
    Refused: 'Refused'
  };
  const terminal_label = Reflect.get(terminal_status_map, status_label);
  return terminal_label;
}

function fallback_sla_label(status_label) {
  const fallback_label = status_label === 'Overdue' ? 'Overdue' : 'On clock';
  return fallback_label;
}

function days_remaining_label(status_label, difference) {
  if (status_label === 'Overdue' || difference < 0) return `${Math.abs(difference)}d over`;
  return `${difference}d`;
}

function dsar_sla_copy(status_label, due_value) {
  const terminal_label = terminal_sla_label(status_label);
  if (terminal_label) return terminal_label;
  const today = new Date('2026-06-29T00:00:00');
  const due_date = parse_display_date(due_value);
  if (!due_date) return fallback_sla_label(status_label);
  const difference = days_between(today, due_date);
  return days_remaining_label(status_label, difference);
}

export function build_dsar_row(row) {
  const dsar_status_class_map = {
    Closed: 'bg-success-subtle text-success-emphasis',
    Overdue: 'bg-danger-subtle text-danger-emphasis',
    Refused: 'bg-secondary-subtle text-secondary-emphasis'
  };
  const status = {
    label: row.status_label,
    class: Reflect.get(dsar_status_class_map, row.status_label) || 'bg-warning-subtle text-warning-emphasis'
  };
  const dsar_row = {
    ref: row.ref,
    subject: row.subject,
    type: row.type,
    received: row.received,
    due: row.due,
    sla: dsar_sla_copy(row.status_label, row.due),
    owner: row.owner,
    status
  };

  return dsar_row;
}
